import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DOWNLOAD_ICON } from '../utils/svgIcons';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import Swal from 'sweetalert2';
import { decrypt, encrypt } from '../services/crypto-js.service';
import { environment } from 'src/environments/environment';
import { CarruselService } from '../services/carrusel.service';
import { getS3File, upload, uploadFileS3 } from '../utils/s3';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as FileSaver from 'file-saver';
import { LAYOUTS, TIME_PICKER_LIST } from '../utils/constants';
import { AttachmentFunctionsComponente } from './attachment-functions/attachment-functions.component';

@Component({
  selector: 'app-banner-editor',
  templateUrl: './banner-editor.component.html',
  styleUrls: ['./banner-editor.component.scss']
})
export class BannerEditorComponent implements OnInit {
  @ViewChild('labelImport')
  labelImport: ElementRef;
  @ViewChild(AttachmentFunctionsComponente)
  attachmentFunctionsRef: AttachmentFunctionsComponente;
  fileToUpload: File = null;
  carruselForm: FormGroup
  employeesArrayList: any = [];
  enlacesZeus: any = [];
  props: any = [];
  showAllowedEmployees: boolean = true
  udnSegmentation: boolean = true
  readonly width_valid_icon: number = 846;
  readonly height_valid_icon: number = 360;
  iconName: string = ''
  url_preview_icon: any = "";
  textDemo: string = ""
  fileName: string = null
  dropdownValue: any = null
  attempts: number = 0;
  editingBanner: boolean
  onUpdateSegmentation: boolean = false
  onEditApiData: any = [];
  existingAttachments: any = null;
  timePickerList: any = TIME_PICKER_LIST
  instructions: string = 'Url de link externo'
  dropdownArray: any = []
  /* dropdownArray: dropdownB[] = [
    {label: 'Link externo',  value: '1', selected: true},
    {label: 'Módulo en Zeus ',  value: '3', selected: false},
    {label: 'Deep link ',  value: '2', selected: false},
  ]; */

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private ngxService: NgxUiLoaderService,
    private carruselService: CarruselService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer ) {
    iconRegistry.addSvgIconLiteral('icon-download', sanitizer.bypassSecurityTrustHtml(DOWNLOAD_ICON));
  }

  async ngOnInit() {
    this.props = history.state
    this.initForm()
    this.getCatalogo()
    this.getZeusModules()

    //CREANDO BANNER
    if(this.props.item === 0) {
      this.editingBanner = false
    }
    //EDITANDO PERFIL
    else {
      this.editingBanner = true
      this.existingAttachments = this.props.item?.attachmen ?? null;
      await this.editingForm(this.props.item.idBanner)
      this.carruselForm.get("segmentation").setValue(this.udnSegmentation);
    }
  }

  initForm() {
    const isBannerFunction = this.props.bannerType == 5
    this.carruselForm = new FormGroup({
      nombre: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      dateInit: new FormControl('', [Validators.required]),
      dateEnd: new FormControl('', [Validators.required]),
      timeInit: new FormControl(''),
      timeEnd: new FormControl(''),
      urlLink: new FormControl({value:'', disabled: isBannerFunction}, isBannerFunction ? [] : [Validators.required]),
      imagen: new FormControl(''),
      urlIcono: new FormControl(''),
      type: new FormControl('1'),
      segmentation: new FormControl(true),
      attachments: new FormControl(null, isBannerFunction ? [Validators.required] : []),
    });
  }



  async getZeusModules() {
    try {
      this.ngxService.start();
      if (this.attempts > 2) {
        this.ngxService.stop();
        return this.showAlert(
          'Error al obtener información', `Lo sentimos, hubo un problema en el servicio, favor de volver a intentar.`
        )
      }

      let object = {
        data:{ }
      }
      const encoded: any = await encrypt(object);
      const result:any = await this.carruselService.getModules({ data: encoded.data })
      const decoded: any = await decrypt({ data: result.data });
      let response: any = decoded.data

      if (response.code === 200) {
        this.enlacesZeus = response.items[0].enlaces
        this.ngxService.stop();
      }

    } catch (error) {
      this.attempts++;
      console.log(error, 'INTENTO: ', this.attempts);
      setTimeout(() => {
        this.getZeusModules()
        this.ngxService.stop();
      }, 1000);
    }
  }

  async getCatalogo() {
    try {
      this.ngxService.start();
      if (this.attempts > 2) {
        this.ngxService.stop();
        return this.showAlert(
          'Error al obtener información', `Lo sentimos, hubo un problema en el servicio, favor de volver a intentar.`
        )
      }

      let object = {
        data:{ }
      }
      const encoded: any = await encrypt(object);
      const result:any = await this.carruselService.getCatalogo({ data: encoded.data })
      const decoded: any = await decrypt({ data: result.data });
      let response: any = decoded.data
      let arreglo: any = []

      if (response.code === 200) {
        response.items[0].tiposLink.forEach(element => {
          arreglo.push({ idTipoLink: element.idTipoLink, tipoLink: element.tipoLink, selected: false })
        });

        //BANNER TERCIARIO MUESTRA OPCION 4 CATALOGO FINANCIERO
        if ( this.props.bannerType == 3 ) {
          this.dropdownArray = arreglo
        }
        else {
          this.dropdownArray = arreglo.filter(tipo => tipo.idTipoLink != 4);
        }

        this.dropdownArray[0].selected = true
        this.ngxService.stop();
      }

    } catch (error) {
      this.attempts++;
      console.log(error, 'INTENTO: ', this.attempts);
      setTimeout(() => {
        this.getZeusModules()
        this.ngxService.stop();
      }, 1000);
    }
  }

  async editingForm(bannerId: any) {
    try {
      if (this.attempts > 2) {
        this.ngxService.stop();
        return this.showAlert(
          'Error al obtener información', `Lo sentimos, hubo un problema en el servicio, favor de volver a intentar.`
        )
      }

      let object = {
        data: {
          idBanner: bannerId
        }
      }
      const encoded: any = await encrypt(object);
      const result: any = await this.carruselService.getEditData({ data: encoded.data })
      const decoded: any = await decrypt({ data: result.data });
      let response: any = decoded.data

      if (response.code === 200) {
        this.onEditApiData = response.items[0].banner
        this.iconName = 'imagen.png'
        this.udnSegmentation = this.onEditApiData.idAsignacion === 1 ? false : true
        this.url_preview_icon = this.onEditApiData.urlIcono
        this.employeesArrayList.allowed = []
        this.employeesArrayList.notAllowed = []

        // Extraer attachments existentes para pasarlos al componente hijo
        // (ya se leen desde this.props.item.attachmen en ngOnInit)

        this.optionSelected(this.onEditApiData.tipo) // 1 Link banner, 2 Deep link, 3 Modulo Zeus
        const onTime: any = this.configureMinutesOnDate(this.onEditApiData)

        if (!this.udnSegmentation) {
          this.fileName = 'Layout.xlsm'

          for (let item of response.items[0].colaboradores) {
            this.employeesArrayList.allowed.push(item)
          }
        }

        this.carruselForm.patchValue({
          nombre: this.onEditApiData.nombre,
          dateInit: new Date(this.onEditApiData.fechaInicio),
          dateEnd: new Date(this.onEditApiData.fechaFin),
          timeInit: onTime.fInicio.slice(0, 5),
          timeEnd: onTime.fFin.slice(0, 5),
          urlLink: this.onEditApiData.urlLink,
          urlIcono: this.onEditApiData.urlIcono,
          type: this.onEditApiData.tipo,
          segmentation: this.onEditApiData.idAsignacion === 2 ? true : false,
          attachments: this.existingAttachments,
        });
      }

    } catch (error) {
      this.attempts++;
      console.log(error, 'INTENTO: ', this.attempts);
      setTimeout(() => {
        this.editingForm(this.props.item.idBanner);
        this.ngxService.stop();
      }, 1000);
    }
  }

  configureMinutesOnDate(parametersForm: any): any {
    const arr: any = {}
    let aux: any = parametersForm.fechaFin.split(':')

    arr.fInicio = new Date(parametersForm.fechaInicio)
    arr.fFin = new Date(parametersForm.fechaFin)

    if (aux[1] != '00') {
      arr.fFin.setTime(arr.fFin.getTime() + (1 * 60 * 1000)); // Agrega un minuto a fecha fin
    }

    arr.fInicio = arr.fInicio.toTimeString('es-MX');
    arr.fFin = arr.fFin.toTimeString('es-MX');

    return arr
  }

  onKey(event: any) {
    this.textDemo = event.target.value;
  }

  changeView(route: string) {
    const user: any = JSON.parse(localStorage.getItem("usuario"));
    if (route === 'home') {
      this.router.navigate([`inicio/${user.idUsuario}/${user.idCliente}`]);
    }
    else { return }
  }

  optionSelected(option: any) {
    let caseOpt: string = option.toString()
    this.dropdownValue = option
    this.carruselForm.get("type").setValue(option)

    this.dropdownArray.forEach(element => {
      element.selected = false
    });

    switch (caseOpt) {
      case '1': //Link externo
        this.instructions = 'Url de link externo'
        this.dropdownArray[0].selected = true
        break;
      case '2': // url deep link
        this.instructions = 'Url del deep link'
        this.dropdownArray[1].selected = true
        break;
      case '3': //Modulo Zeus
        this.instructions = 'Módulo en Zeus'
        this.dropdownArray[2].selected = true
        break;
      default:
        console.log("Opcion no valida");
    }

  }

  onFileChange(files: FileList) {
    this.labelImport.nativeElement.innerText = Array.from(files)
      .map(f => f.name)
      .join(', ');
    this.fileToUpload = files.item(0);
  }

  onChangeSegmentation(ev: any) {
    this.udnSegmentation = ev
  }

  onAttachmentsReady(payload: any) {
    const hasFunciones = payload?.funciones?.length > 0;
    const hasMultimediaEmpleados = payload?.multimediaEmpleados?.length > 0;
    const hasEmpleados = !!payload?.empleados;

    if (hasFunciones || hasMultimediaEmpleados || hasEmpleados) {
      this.carruselForm.get('attachments').setValue(payload);
    } else {
      this.carruselForm.get('attachments').setValue(null);
    }
  }

  /** Texto dinámico del botón Guardar para banner tipo 5. */
  get saveButtonLabel(): string {
    if (this.props.bannerType !== 5) return 'Guardar';
    switch (this.attachmentFunctionsRef?.typeAttachment) {
      case 1:  return 'Guardar funciones';
      case 2:  return 'Guardar carga masiva';
      case 3:  return 'Guardar números de empleado';
      default: return 'Guardar';
    }
  }

  /**
   * Filtra el payload completo de attachments para enviar únicamente
   * la sección correspondiente a la pestaña activa en el componente hijo.
   * Las secciones inactivas viajan como [] o null según el contrato del backend.
   */
  buildAttachmentByType(payload: any): any {
    if (!payload) return null;
    switch (payload.typeAttachment) {
      case 1: // Carga por función
        return {
          funciones: payload.funciones ?? [],
          multimediaEmpleados: [],
          empleados: null,
        };
      case 2: // Carga masiva (excel)
        return {
          funciones: [],
          multimediaEmpleados: [],
          empleados: payload.empleados ?? null,
        };
      case 3: // Carga por número de empleado
        return {
          funciones: [],
          multimediaEmpleados: payload.multimediaEmpleados ?? [],
          empleados: null,
        };
      default:
        return payload;
    }
  }

  async generateBanner(modal: any, notAllowedModal: any) {
    const onError: boolean = this.validateDate(this.carruselForm.value)

    if (onError) { return }

    this.ngxService.start();
    const idPermiso: number = this.validateBannerType(this.props.bannerType)
    const user: any = JSON.parse(localStorage.getItem("usuario"));
    const form: any = this.carruselForm.value
    const date = new Date();
    const formatDate = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
    let response: any = []

    //SEGMENTACION POR EXCEL
    if (!this.udnSegmentation) {
      let jsonEmployee: any = []

      for (const element of this.employeesArrayList.allowed) {
        jsonEmployee.push(element.employee_number)
      }

      const text = `{idPermiso:${idPermiso},empleados:${JSON.stringify(jsonEmployee)}}`
      const pathKey = `red-unica/banner-carrusel/${formatDate}/employees${date.getTime()}.json`
      response = await upload(environment.AWS_CONFIG.bucket, pathKey, text, 'text/plain')
    }

    try {
      let object = {
        data: {
          idPermiso: idPermiso,
          nombre: form.nombre,
          urlIcono: form.urlIcono,
          urlLink: form.urlLink,
          fechaInicio: this.formatDate(form.dateInit, 'init'),
          fechaFin: this.formatDate(form.dateEnd, 'end'),
          bucket: environment.AWS_CONFIG.bucket,
          key: this.udnSegmentation ? '' : response.Key,
          idAsignacion: this.udnSegmentation ? 2 : 1,   //1 CARGA EXCEL -- 2 CARGA UDN
          idTipo: parseInt(form.type),
          udn: parseInt(user.idCliente),
          usuarioModifico: user.idUsuario,
          idTipoLink: parseInt(form.type), //1 LINK EXTERNO, 2 DEEP LINK, 3 MODULO ZEUS 
          idSector: this.props.bannerType, //1 PRINCIPAL, 2 SECUNDARIO, 3 TERCIARIO, 4 SAC, 5 FUNCIONES
          attachmen: this.buildAttachmentByType(form.attachments),
          orden: this.props.bannerType 
        }
      }

      const encoded: any = await encrypt(object);
      const result: any = await this.carruselService.createBanner({ data: encoded.data })
      const decoded: any = await decrypt({ data: result.data });
      if (decoded.data.message.id === 21) {
        this.ngxService.stop();
        return this.modalService.open(notAllowedModal, { size: 'sm', backdrop: 'static', centered: true });
      }

      if (decoded.data.code === 200) {
        // Para banner tipo 5 el usuario puede continuar editando secciones:
        // convertimos el estado a "edición" con el idBanner recién creado
        if (this.props.bannerType === 5) {
          const created = decoded.data.items[0];
          this.editingBanner = true;
          this.onEditApiData = created;
        }
        this.ngxService.stop();
        this.modalService.open(modal)
      }
      else {
        this.ngxService.stop();
        return this.showAlert('Algo salió mal', `Espere unos segundos y vuelva a intentar por favor.`)
      }

    } catch (error) {
      this.ngxService.stop();
      console.log(error);
      return this.showAlert('Error al crear banner', `Espere unos segundos y vuelva a intentar por favor.`)

    }
  }

  validateBannerType(type: number): number {
    let indexBanner: number = null

    type == 1 ? indexBanner = 476 // El Mejor Fin en Elektra
      : type == 2 ? indexBanner = 466 // Las mejores promociones
        : type == 3 ? indexBanner = 496 // Catálogo financiero Movilidad
          : type == 4 ? indexBanner = 555 // SAC (555 )
            : type == 5 ? indexBanner = 739 // FUNCIONES
              : type == 6 ? indexBanner = 753 // Mi Copiloto
              : null

    return indexBanner
  }

  validateDate(formValue: any): boolean {
    let now = new Date();
    let dInit = new Date(formValue.dateInit)
    let dEnd = new Date(formValue.dateEnd)
    now.setHours(0, 0, 0, 0);

    if (!this.udnSegmentation && this.employeesArrayList.allowed === undefined) {
      this.showAlert('Sin audiencia', `Para continuar por favor cargue la audiencia a la que va dirigido el banner.`)
      return true
    }

    if (formValue.imagen === '' && !this.editingBanner) {
      this.showAlert('Sin imagen', `Para continuar por favor cargue una imagen con las especifiaciones marcadas.`)
      return true
    }

    if (dInit.getTime() == dEnd.getTime()) {
      if (formValue.timeInit > formValue.timeEnd) {
        this.showAlert('Fecha no valida', `La fecha inicial no puede ser mayor a la final.`)
        return true
      }
    }

    if (formValue.dateInit > formValue.dateEnd) {
      this.showAlert('Fecha no valida', `La fecha inicial no puede ser mayor a la final.`)
      return true
    }

    if (formValue.dateEnd < now) {
      this.showAlert('Fecha no valida', `Las fechas no pueden ser anteriores al dia de hoy`)
      return true
    }

    else {
      return false
    }
  }

  async updateBanner(modal: any, notAllowedModal: any) {
    const onError: boolean = this.validateDate(this.carruselForm.value)

    if (onError) { return }

    try {
      this.ngxService.start();
      const idPermiso: number = this.validateBannerType(this.props.bannerType)
      const user: any = JSON.parse(localStorage.getItem("usuario"));
      const form: any = this.carruselForm.value
      let newSegmentation: string = null

      //ON UPDATE SEGMENTATION
      if (this.onUpdateSegmentation) {
        console.log('SE ACTUALIZA SEGMENTACION')
        const date = new Date();
        const formatDate = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
        let jsonEmployee: any = []

        for (const element of this.employeesArrayList.allowed) {
          jsonEmployee.push(element.employee_number)
        }

        const text = `{idPermiso:${idPermiso},empleados:${JSON.stringify(jsonEmployee)}}`
        const pathKey = `red-unica/banner-carrusel/${formatDate}/employees${date.getTime()}.json`
        let aux: any = await upload(environment.AWS_CONFIG.bucket, pathKey, text, 'text/plain')
        newSegmentation = aux.key
      }

      let object = {
        data: {
          nombre: form.nombre,
          urlIcono: form.urlIcono,
          urlLink: form.urlLink,
          fechaInicio: this.formatDate(form.dateInit, 'init'),
          fechaFin: this.formatDate(form.dateEnd, 'end'),
          bucket: environment.AWS_CONFIG.bucket,
          key: !this.onUpdateSegmentation ? this.onEditApiData.key : newSegmentation,
          idPermiso: idPermiso,
          idAsignacion: this.udnSegmentation === true ? 2 : 1,   //1 CARGA EXCEL -- 2 CARGA UDN
          idTipo: parseInt(form.type),
          usuarioModifico: user.idUsuario,
          udn: parseInt(user.idCliente),
          idTipoLink: parseInt(form.type), //1 LINK EXTERNO, 2 MODULO EXTERNO, 3 DEEP LINK
          idSector: this.props.bannerType, //1 PRINCIPAL, 2 SECUNDARIO, 3 TERCIARIO,
          attachmen: this.buildAttachmentByType(form.attachments),
          orden: this.onEditApiData.orden ?? ""
        }
      }

      const encoded: any = await encrypt(object);
      const result: any = await this.carruselService.updateBanner(
        { data: encoded.data },
        this.onEditApiData.idBanner,
        user.idUsuario
      )
      const decoded: any = await decrypt({ data: result.data });

      if (decoded.data.message.id === 21) {
        this.ngxService.stop();
        return this.modalService.open(notAllowedModal, { size: 'sm', backdrop: 'static', centered: true });
      }

      if (decoded.data.code === 200) {
        this.ngxService.stop();
        this.modalService.open(modal)
      }
      else {
        this.ngxService.stop();
        return this.showAlert('Algo salió mal', `Espere unos segundos y vuelva a intentar por favor.`)
      }

    } catch (error) {
      this.ngxService.stop();
      console.log(error);
      return this.showAlert('Error al crear banner', `Espere unos segundos y vuelva a intentar por favor.`)

    }
  }

  formatDate(oDate: Date, type: string) {
    let timeForm: any = this.carruselForm.value

    let oTempDate = new Date(oDate),
      sMonth = '' + (oTempDate.getMonth() + 1),
      sDay = '' + oTempDate.getDate(),
      iYear = oTempDate.getFullYear();

    if (sMonth.length < 2) { sMonth = '0' + sMonth; }
    if (sDay.length < 2) { sDay = '0' + sDay; }

    if (type === 'init') {
      return [iYear, sMonth, sDay].join('-') + ' ' + timeForm.timeInit + ':' + '00'
    }
    else {
      return [iYear, sMonth, sDay].join('-') + ' ' + timeForm.timeEnd + ':' + '00'
    }
  }

  /* formatDate(oDate: Date, type: any) {
    let oTempDate = new Date(oDate),
    sMonth = '' + (oTempDate.getMonth() + 1),
    sDay = '' + oTempDate.getDate(),
    iYear = oTempDate.getFullYear();

    if (sMonth.length < 2) { sMonth = '0' + sMonth; }
    if (sDay.length < 2) { sDay = '0' + sDay; }

    let onDate: any = [iYear, sMonth, sDay].join('-')

    if ( type === 'init') {
      return onDate + ' 00:00:00';
    }
    if ( type === 'end') {
      return onDate + ' 23:59:59';
    }
    else {
      return null
    }
  } */

  onChangeTable(ev: any) {
    this.showAllowedEmployees = ev
  }

  loadImage(item: any) {
    item.preventDefault();
    const file = item.target.files[0];

    if (file === undefined) { return }

    this.ngxService.start();
    const match = ["image/jpeg", "image/png", "image/jpg"];

    //VALIDACION FORMATO IMAGEN
    if (match.includes(file.type)) {

      //VALIDACION TAMAÑO IMAGEN 
      if ((file.size * 0.000001) < 15) {

        //LOAD PREVIEW IMAGE
        const reader = new FileReader();
        reader.onload = async () => {

          const image = new Image();
          image.src = reader.result as string,
            image.title = file.name;

          image.onload = async () => {

            if (image.naturalWidth != this.width_valid_icon || image.naturalHeight != this.height_valid_icon) {
              this.ngxService.stop();
              this.showAlert('Medidas no válidas', `Las medidas de imagen deben ser ${this.width_valid_icon} px por ${this.height_valid_icon} px`)
              return;
            }
            else {
              this.iconName = file.name
              this.url_preview_icon = reader.result as string;
              const response = await this.uploadIconToS3(file)
              console.log('Location :>> ', response.Location);
              this.carruselForm.get("urlIcono").setValue(response.Location);
              this.ngxService.stop();
            }
          }
        }
        reader.readAsDataURL(file)
      }
      else {
        this.ngxService.stop();
        return this.showAlert('Tamaño no valido', `La longitud del archivo ${file.name} excede el peso permitido. (500 KB)`)
      }
    }
    else {
      this.ngxService.stop();
      return this.showAlert('Aviso', 'Solo se permiten archivos formato .png, .jpg, .jpeg');
    }
  }

  showAlert(title: string, message: string) {
    Swal.fire({
      title: title,
      icon: 'info',
      text: message,
      confirmButtonColor: '#545D6E',
      confirmButtonText: '<span style="color: #ffffff"> Entendido </span>',
    })
  }

  async downloadFile(templateName: string) {
    this.ngxService.start();
    let layout: string = '';
    templateName === 'Carga_empleados' ? layout = LAYOUTS.EMPLOYEES : layout = LAYOUTS.CUSTOMIZED
    try {
      const file = await getS3File(environment.AWS_CONFIG.credentials.structureBucket, layout);
      this.saveAsExcelFile(file.Body, templateName);
    } catch (err) {
      this.ngxService.stop();
      return this.showAlert('Error en descarga', `Lo sentimos, hubo un problema en la descarga del archivo, favor de volver a intentar.`)
    }
  }

  saveAsExcelFile(buffer: any, name: string): void {
    try {
      const data: Blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      });
      FileSaver.saveAs(data, name + '.xlsm');
      this.ngxService.stop();
    } catch (e) {
      console.log(e);
    }
  }

  async uploadIconToS3(file: any): Promise<any> {
    try {
      const dt = new Date();
      const str = dt.toString().split(' ');
      const regEx = new RegExp(':', "g");
      const time = str[4].replace(regEx, '-');

      let year = dt.getFullYear();
      let month = (dt.getMonth() + 1).toString().padStart(2, "0");
      let day = dt.getDate().toString().padStart(2, "0");
      let now: any = year + '/' + month + '/' + day;

      //let key: string = `permisos-iconos/las_mejores_prmociones_png/test.png`
      let key: string = `red-unica/banner-carrusel/${now}/image${time}.png`
      const response: any = await uploadFileS3(file, key)
      return response

    } catch (error) {
      this.iconName = null
      console.log(error);
      this.ngxService.stop()
    }
  }

}
